import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HomeService } from '../services/home.service';
import { SharedModule } from '@app/shared/shared.module';
import { Router } from '@angular/router';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Utilities } from '@app/core/utils/utilities';
import { ValidatorFunctions } from '@app/shared/util/validator-functions';
import { Observable, take } from 'rxjs';
import { ApiService } from '@app/shared/services/api.service';
import { InstitutionSelectionPageComponent } from '../institution-selection-page/institution-selection-page.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConstantVariables } from '@app/shared/util/constant-variables';

@Component({
    selector: 'app-home-landing-page',
    imports: [CommonModule, SharedModule, InstitutionSelectionPageComponent],
    providers: [HomeService],
    templateUrl: './home-landing-page.component.html',
    styleUrl: './home-landing-page.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeLandingPageComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
  private router = inject(Router);
  private homeApiService = inject(HomeService);
  private commonApiService = inject(ApiService);
  private util = inject(Utilities);
  private validatorFn = inject(ValidatorFunctions);
  constantVariable = inject(ConstantVariables);
  private dialogRef: any;
  countryForm = signal<FormGroup | null>(null);
  countryData$!: Observable<any>;
  countryList = signal<any[]>([]);
  globalCountryList = signal<any[]>([]);
  showGlobalCountry = signal(false);
  institutionList = signal<any[]>([]);
  dialogData = signal(false);
  editableRoles = ['SCC Admin', 'Data Team Leader'];
  readonlyRoles = ['Data Validator', 'Data Analyst', 'SCC View Only'];
  userRole = this.util.getStoredUserDetails().roleName ?? '';

  constructor() {
    if (!this.router.url.includes('/home')) {
      this.dialogRef = inject(MatDialogRef<HomeLandingPageComponent>);
      this.dialogData.set(true);
    }
  }

  ngOnInit(): void {
    this.getCountryDetails();
    if (this.router.url.includes('/home')) {
      this.homeApiService.getInstitutionDetails(9, { 'hideLoader': 'true' }).pipe(take(1)).subscribe();
      this.util.institutionDetails.set('');
      localStorage.removeItem('institutionDetails');
      localStorage.removeItem('countryDetails');
      this.util.getInstituionDetails();
    }
  }

  getCountryDetails() {
    this.countryData$ = this.commonApiService.getCountryData();
    this.countryData$.subscribe({
      next: (data: any) => {
        if (data?.countries) {
          const filteredCountry = data.countries?.filter((country: any) => country?.dataStandardId !== 999);
          filteredCountry.push({
            countryId: null,
            countryName: "Other markets"
          })
          this.countryList.set(filteredCountry);
          this.globalCountryList.set(data.countries?.filter((country: any) => country?.dataStandardId === 999));
          this.countryForm.set(this.createFormGroup());
        }
      },
      error: (error: any) => {
        console.log("errorlog", error);
        this.countryList.set([]);
        this.globalCountryList.set([]);
        this.countryForm.set(this.createFormGroup());
      }
    });
  }

  createFormGroup(selectedCountry?: any, from?: string): FormGroup {
    const formGrp: any = {};
    formGrp['countryId'] = new FormControl((selectedCountry || ''), Validators.required);
    formGrp['institutionId'] = new FormControl('', [Validators.required, this.validatorFn.ajaxValidator('institutionName')]);
    if (!from && selectedCountry && !selectedCountry?.countryId)
      formGrp['globalCountryId'] = new FormControl('', Validators.required);
    return new FormGroup(formGrp);
  }

  getInstitutionList(event: any) {
    this.institutionList.set([]);
    const selectedCountry = event.countryEvent.value || '';
    if (!event.from) {
      this.countryForm.set(this.createFormGroup(selectedCountry, event.from));
      this.showGlobalCountry.set(!selectedCountry?.countryId);
    } else {
      this.countryForm()?.get('institutionId')?.setValue('');
    }
    if (selectedCountry?.countryId)
      this.homeApiService.getInstitutionDetails(selectedCountry?.countryId).subscribe({
        next: (data: any) => {
          if (data?.institutions)
            this.institutionList.set(data.institutions?.map((inst: any) => {
              return { ...inst, institutionDisplayName: inst.institutionName + ' (' + inst.institutionId + ')' }
            }));
        }
      });
  }


  getInstitutionData() {
    if (!this.router.url.includes('/home')) {
      this.util.institutionDetails.set('');
      localStorage.removeItem('institutionDetails');
      localStorage.removeItem('countryDetails');
    }
    const form = this.countryForm();
    if (!form) return;
    const instDetails = JSON.stringify(form.value.institutionId);
    let countryDetails = JSON.stringify(form.value.countryId);
    const countrySelected = form.value.countryId;
    if (countrySelected.countryId === null)
      countryDetails = JSON.stringify(form.value.globalCountryId);
    localStorage.setItem('institutionDetails', instDetails);
    this.util.getInstituionDetails();
    localStorage.setItem('countryDetails', countryDetails);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    if (!this.router.url.includes('/home'))
      this.dialogRef.close();
    this.router.navigateByUrl((['SCC Admin', 'Data Team Leader', 'Data Validator', 'Data Analyst'].includes(this.userRole)? '/edit-institution/':'/view-institution/') + JSON.parse(instDetails)?.institutionId, { state: { institutionName: JSON.parse(instDetails)?.institutionName } })
  }

  redirectToViewAllInstitution() {
    this.router.navigateByUrl('/manage-institution');
  }
}
